// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".bg-blue-50[data-v-22a4d859] {\n  background-color: rgba(1, 107, 255, 0.1);\n}\n.required-icon[data-v-22a4d859] {\n  color: #ff766e;\n  margin-right: 4px;\n}\n.subText[data-v-22a4d859] {\n  color: var(--colorTextDescription, rgba(0, 0, 0, 0.45));\n  margin-left: 4px;\n  font-family: Outfit;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: normal;\n}", ""]);
// Exports
module.exports = exports;
